import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Tag, Spin, Typography, Row, Col, Input, message } from 'antd';
import { NavBar, Popup, List, Dialog } from 'antd-mobile';
import { RootState } from '@/store';
import Loading from '@/components/Loading';
import RtcClient from '@/lib/RtcClient';
import {
  clearCurrentMsg, setInterruptMsg, updateAIGCState,
} from '@/store/slices/room';
import Config from '@/config';
import styles from './index.module.less';
import WaveGIF from '@/assets/img/Wave.gif';
import DoubaoProfileSVG from '@/assets/img/user_cyber.png';
import StopRobotBtn from '@/assets/img/StopRobotBtn.svg';
import { AddOutline, CalendarOutline, CloseOutline, DeleteOutline, SendOutline } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import { post } from '@/utils/request';
import openAPIs from '@/app/api';
import aigcConfig from '@/config';

import {
  setHistoryMsg,
} from '@/store/slices/room';

const { Search } = Input;

const lines: (string | React.ReactNode)[] = [
  <div key="problem1">
    <Tag className={styles.tagProblem}>What is the meaning of life?</Tag>
  </div>,
  <div key="problem2">
    <Tag className={styles.tagProblem}>How to balance personal goals and family expectations?</Tag>
  </div>,
  <div key="problem3">
    <Tag className={styles.tagProblem}>Can I stop working hard in competitive society?</Tag>
  </div>,
];

function Conversation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //历史消息
  const msgHistory = useSelector((state: RootState) => state.room.msgHistory);

  //用户信息
  const { userId } = useSelector((state: RootState) => state.room.localUser);

  //房间信息
  const { isAITalking, isUserTalking, roomId, isAIGCEnable } = useSelector((state: RootState) => state.room);
  const isAIReady = msgHistory.length > 0;
  const containerRef = useRef<HTMLDivElement>(null);

  //弹窗
  const [popupVisible, setPopupVisible] = useState(false);

  //当前状态
  const [status, setStatus] = useState('voice');

  useEffect(() => {
    //处理页面的scrollTop
    const container = containerRef.current;
    if (container) {
      container.scrollTop = container.scrollHeight - container.clientHeight;
    }
  }, [msgHistory.length]);

  /**
   * 处理打断
   */
  const handleInterrupt = () => {
    RtcClient.commandAudioBot(roomId!, userId!, 'interrupt');
    dispatch(setInterruptMsg());
  };

  /**
   * 处理aigc模式
   * @param roomId
   * @param userId
   */
  const handleAIGCModeStart = async (roomId: any, userId: any) => {
    if (isAIGCEnable) {
      await RtcClient.stopAudioBot(roomId, userId);
      dispatch(clearCurrentMsg());
      await RtcClient.startAudioBot(roomId, userId);
    } else {
      await RtcClient.startAudioBot(roomId, userId);
    }
    dispatch(updateAIGCState({ isAIGCEnable: true }));
  };

  /**
   * 结束当前会话
   */
  const stopConversation = () => {
    //结束当前会话
    let conversationId = localStorage.getItem('conversationId');
    post('/cbc/conversation/ops/stop', {
      conversationId: conversationId,
    }).then((res) => {
      console.log(res);
    });
  };

  /**
   * 开启新会话
   */
  const startNewConversation = async () => {
    //结束当前会话
    stopConversation();

    //开启会话
    //处理aigc模式
    await handleAIGCModeStart(roomId, userId);
  };



  /**
   * 文本输入框
   */
  const [content, setContent] = useState<any>('');
  const onChange = async (e: any) => {
    setContent(e.target.value);
  };
  const onSearch = async (value: any) => {
    console.log(value);
    //发送文字
    const res = await openAPIs.UpdateVoiceChat({
      AppId: aigcConfig.AppId,
      RoomId: roomId,
      TaskId: userId,
      Command: 'ExternalTextToLLM',
      Message: value,
      InterruptMode: 1,
    });
    //记录消息
    //{
    //     "text": "你好，欢迎来到我的咨询室。我是儒家哲学咨询智能体 — 赛博子曰，我精通孔子哲学思想，擅长帮助人们解决思想和观念上的困惑。我的",
    //     "user": "RTCBotTest",
    //     "paragraph": false,
    //     "definite": false
    // }
    dispatch(setHistoryMsg({
      text: value,
      user: userId,
      paragraph: true,
      definite: false,
    }));
    setContent('');
  };

  //会话列表
  const [conversationList, setConversationList] = useState<any>([]);
  const onDateChoose = () => {
    //日期列表
    console.log((new Date()).toISOString().substring(0, 10));
    post('/cbc/history/list/by-date', {
      date: (new Date()).toISOString().substring(0, 10),
    }).then((res) => {
      console.log(res);
      if (res.code === 200) {
        setConversationList(res.data);
      }
    });
  };

  //登录用户信息
  const [userInfo, setUserInfo] = useState<any>({});
  useEffect(() => {
    //加载用户
    let userInfoStr = localStorage.getItem('userInfo');
    if (userInfoStr !== null) {
      let userInfo = JSON.parse(userInfoStr);
      setUserInfo(userInfo);
    }
    //当日咨询记录
    onDateChoose();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      //结束当前会话
      stopConversation();
    };

    //监听tab关闭
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const clearAll  = () => {
    Dialog.show({
      title: 'Are you sure you want to delete all records?',
      content: 'After confirmation, all records will be deleted and cannot be recovered.',
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: 'cancel',
          },
          {
            key: 'delete',
            text: 'delete',
            bold: true,
            danger: true,
            onClick: ()=>{
              post("/cbc/history/deleteAll",{}).then((res)=>{
                if(res.code === 200){
                  setPopupVisible(false);
                }else{
                  message.error(res.msg)
                }
              })
            }
          },
        ],
      ],
    })
  }

  return (
    <div className={styles.conversationContainer}>

      <NavBar
        className={styles.navBar}
        style={{ height: 65 }}
        children={<img src={require('@/assets/img/title.png')} style={{ height: 35 }} alt="" />}
        backIcon={<img src={require('@/assets/img/menu.png')} style={{ height: 25 }} alt="" />}
        onBack={() => {
          setPopupVisible(true);
        }}
      />

      <div className={styles.wrapper}>
        <div ref={containerRef} className={styles.conversation}>
          <div key="doubao_profile" style={{ textAlign: 'center' }}>
            <img className={styles.doubaoIcon} key="doubao_profile" src={DoubaoProfileSVG}
                 alt="doubao_profile" />
          </div>

          {!isAIReady ? (
            <div className={styles.aiReadying}>
              <Spin size="small" className={styles['aiReading-spin']} />
              AI is preparing. Please wait a moment.
            </div>
          ) : (
            ''
          )}
          {msgHistory?.map(({ value, user, isInterrupted }, index) => {
            const isUserMsg = user === userId;
            const isRobotMsg = user === Config.BotName;
            if (!isUserMsg && !isRobotMsg) {
              return '';
            }
            // 欢迎词
            if (index === 0) {
              return (
                <div key="msg-welcome">
                  <div className={` ${isUserMsg ? styles.user : styles.robot}`}>
                    <div>{value}</div>
                  </div>
                  <div>{index === 0 && lines.map((line) => line)}</div>
                </div>
              );
            }
            // 对话内容
            return (
              <div className={`${styles.sentence} ${isUserMsg ? styles.user : styles.robot}`}
                   key={`msg-${index}`}>
                {/*对话内容*/}
                <span>{value}</span>
                {/*打断*/}
                {!isUserMsg && isInterrupted ? (
                  <>
                    ...
                    <Tag className={styles.interruptTag}>Interrupted</Tag>
                  </>
                ) : (
                  ''
                )}
                {/*对话中*/}
                {isAITalking && index === msgHistory.length - 1 ? <Loading /> : ''}
              </div>
            );
          })}

          {isAITalking ? (
            <Button type="text" onClick={handleInterrupt} className={styles.interrupt}
                    icon={<img src={StopRobotBtn} alt="StopRobotBtn" />}>
              Manually stopped, or interrupted by voice.
            </Button>
          ) : (
            ''
          )}
          {isUserTalking ? (
            <div key={`loading-isUserTalking-${isUserTalking}`}
                 className={`${styles.sentence} ${styles.user}`}>
              <Loading />
            </div>
          ) : (
            ''
          )}
        </div>

        {/*状态*/}
        <div className={styles.status}>
          {
            status === 'voice' && <>
              <Row>
                <Col span={3}>
                  <img className={styles.keyword} src={require('@/assets/img/keyword.png')} alt="" onClick={() => {
                    setStatus('keyword');
                  }} />

                </Col>
                <Col span={21}>
                  <img className={isUserTalking ? styles.userTalkingWave : styles.userStopTalkingWave}
                       src={WaveGIF} />
                  {/*<iframe className={styles.iframe} src="/siri/index.html"></iframe>*/}
                </Col>
              </Row>
            </>
          }
          {
            status === 'keyword' && <>
              <Row>
                <Col span={3}>
                  <img className={styles.keyword} src={require('@/assets/img/voice.png')} alt="" onClick={() => {
                    setStatus('voice');
                  }} />
                </Col>
                <Col span={21}>
                  <Search placeholder="Sending message..."
                          enterButton={<img className={styles.keyword} src={require('@/assets/img/sendout.png')}
                                            alt="" />}
                          value={content}
                          onChange={onChange}
                          onSearch={onSearch} />
                </Col>
              </Row>
            </>
          }

        </div>

      </div>
      <Popup
        visible={popupVisible}
        onMaskClick={() => {
          setPopupVisible(false);
        }}
        position="left"
        bodyStyle={{ width: '80vw' }}
      >
        <div className={styles.popupContent}>
          {
            userInfo && userInfo.status !== 'anonymous' && <>
              <List header="">
                <List.Item prefix={<AddOutline />} arrowIcon={false} onClick={startNewConversation}>
                    New Conversation
                </List.Item>
                <List.Item prefix={<CalendarOutline />} arrowIcon={false} onClick={() => {
                  //结束当前会话
                  stopConversation();
                  //跳转
                  navigate('/history');
                }}>
                    View Consultation History
                </List.Item>
                <List.Item prefix={<DeleteOutline />} arrowIcon={false} onClick={() => {
                  clearAll();
                }} className={styles.clear}>
                    Clear All Records
                </List.Item>
              </List>
              {
                conversationList && conversationList.length > 0 && <List header="consultation records for the day">
                  {
                    conversationList && conversationList.map((item: any) => {
                      return <div key={item.id} className={styles.todayConversation}>
                        <List.Item arrowIcon={false} onClick={()=>{
                          //结束当前会话
                          stopConversation();
                          //跳转
                          navigate('/history/summary?conversationId=' + item.id);
                        }}>
                          {item.title}
                        </List.Item>
                      </div>;
                    })
                  }
                </List>
              }

            </>
          }

          {
            (userInfo === null || (userInfo && userInfo.status === 'anonymous')) && <>
              <div className={styles.tips}>
                <div className={styles.content}>Welcome to log in with your account.</div>
                <div className={styles.content}>Save your consultation records.</div>
                <div className={styles.btn}>
                  <Button ghost style={{ marginTop: 10 }} onClick={() => {
                    //结束当前会话
                    stopConversation();
                    navigate('/login');
                  }}>Sign in</Button>
                  <Button type="text" style={{ marginTop: 10 }} onClick={() => {
                    //结束当前会话
                    stopConversation();
                    navigate('/reg');
                  }}>Register</Button>
                </div>
              </div>
            </>
          }
        </div>
      </Popup>
    </div>
  );
}

export default Conversation;
